import React, { useEffect, useState } from "react";
import { API_URL, EXTRACTION_URL } from "../../helpers/variables";
import {
  List,
  ListItem,
  Button,
  Stack,
  ListItemButton,
  ListItemText,
  Box,
  ListSubheader,
  Tooltip,
  IconButton,
  Tabs,
  Tab,
  CircularProgress,
  Backdrop,
  Dialog,
  Toolbar,
  Typography,
  DialogContent,
  Autocomplete,
  TextField,
  Chip,
  AppBar,
} from "@mui/material";
import Editor from "@monaco-editor/react";
import { Clear, Edit, Upload } from "@mui/icons-material";
import ConfigViewer from "../../Components/ConfigViewer";
import ReportListItems from "../../Components/ReportListItems";

export const uploadReport = (pms) => {
  const input = document.createElement("input");
  input.type = "file";
  input.onchange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    // Defer form creation and submission to allow the file chooser to fully settle
    setTimeout(() => {
      const form = document.createElement("form");
      form.action = `${EXTRACTION_URL}/test_upload`;
      form.method = "POST";
      form.enctype = "multipart/form-data";
      form.target = "_blank";

      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.name = "upload_file";

      // Manually add the selected file using DataTransfer workaround
      const dt = new DataTransfer();
      dt.items.add(files[0]);
      fileInput.files = dt.files;

      const pmsInput = document.createElement("input");
      pmsInput.type = "hidden";
      pmsInput.name = "pms";
      pmsInput.value = pms;

      form.appendChild(fileInput);
      form.appendChild(pmsInput);
      document.body.appendChild(form);

      form.submit();
      document.body.removeChild(form);
    }, 0); // Defer to next tick
  };
  input.click();
};

const Reports = () => {
  const [reports, setReports] = useState([]);
  const [selectedReport, setSelectedReport] = useState(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getReports();
  }, []);

  async function getReports() {
    setLoading(true);
    let res = await fetch(`${API_URL}/get_all_reports`);
    let data = await res.json();
    setReports(data);
    setLoading(false);
  }

  const filteredReports = reports.filter((reportItem) =>
    reportItem.pms.toLowerCase().includes(searchQuery?.toLowerCase())
  );

  return (
    <>
      <Stack direction={"row"} height={"100%"} gap={1}>
        <Stack width={"30%"} border={1} borderColor={"divider"}>
          <Box p={1}>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Search by PMS"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </Box>
          <Box overflow={"auto"}>
            {filteredReports.map((reportItem, index) => (
              <List key={index}>
                <ListSubheader>
                  <Stack direction={"row"} alignItems={"center"}>
                    <Typography flexGrow={1} variant="h6">
                      {reportItem.pms}
                    </Typography>
                    <Box>
                      <IconButton onClick={() => uploadReport(reportItem.pms)}>
                        <Upload />
                      </IconButton>
                    </Box>
                  </Stack>
                </ListSubheader>
                <ReportListItems
                  selectedReport={selectedReport}
                  setSelectedReport={setSelectedReport}
                  reports={reportItem.reports}
                />
              </List>
            ))}
          </Box>
        </Stack>

        {!loading &&
          (selectedReport ? (
            <Box width={"70%"} height={"100%"}>
              <ConfigViewer
                selectedReport={selectedReport}
                reloadList={getReports}
              />
            </Box>
          ) : (
            <Box width={"70%"} display={"grid"} sx={{ placeItems: "center" }}>
              Select the report
            </Box>
          ))}
      </Stack>

      <Backdrop open={loading} sx={{ zIndex: (t) => t.zIndex.tooltip }}>
        <CircularProgress />
      </Backdrop>
    </>
  );
};

export default Reports;
